import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';
import { Button, Card, Typography } from '@mui/material';

/**
 * The properties for the quiz complete card
 */
interface QuizCompleteCardProps {
  /**
   * A function to move to the next module
   * @returns Void
   */
  nextModule: () => void;
}

/**
 * The card to show when the quiz is complete
 */
const QuizCompleteCard = (props: QuizCompleteCardProps) => (
  <Card
    data-testid="quiz-complete-id"
    sx={{
      height: '300px',
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column',
    }}
  >
    <CheckCircleOutlineRoundedIcon
      color="success"
      sx={{
        fontSize: 100,
      }}
    />
    <Typography gutterBottom variant="h2" component="h2" textAlign="center">
      Quiz Complete!
    </Typography>
    <Button
      variant="contained"
      onClick={props.nextModule}
      sx={{ width: '10em' }}
    >
      Next
    </Button>
  </Card>
);

export default QuizCompleteCard;
